<!--<div class="header-title" fxLayout="row" fxLayout.xs="column">
 <div
    class="service-expansion-panel"
    fxFlex="100%;"
    fxFlex.xs="80%"
    fxLayout="column"
    fxLayout.xs="column"
  >
    <div> -->
<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6>{{ misServiceTitle }}</h6>
      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
      &nbsp;&nbsp; &nbsp;
      <button
        class="button-primary"
        id="back"
        bciprimarybutton
        (click)="onBack()"
      >
        {{ 'back' | translate }}
      </button>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <!-- <div
          id="expansion-panel-header"
          fxLayout="row"
          fxLayout.xs="column"
          class="site-layout"
        ></div> -->

  <!-- </div>
  </div> 
</div>-->

  <br />
  <div style="display: flex">
    <div
      id="chart-container-header"
      fxLayout="row wrap"
      fxFlex="100%;"
      fxLayout.xs="row wrap"
    >
      <div
        id="chartContainer"
        class="dashboard-wrapper"
        fxLayout="row wrap"
        fxFlex="49%;"
        fxFlex.lt-xl="100%;"
      >
        <div id="monthly-stats-row" fxFlex="100%;" fxLayoutAlign="center left">
          <div id="monthly-stats-title" fxFlex="50%;">
            <span class="header-title" id="monthly-stats">{{
              'overview.longTermTrends.monthlyStatistics' | translate
            }}</span>
          </div>
          <div id="monthly-stats-end" fxFlex="50%;"></div>
        </div>
        <div
          id="chartContainer1"
          fxFill
          style="
            height: 100%;
            min-height: 100%;
            min-width: 100%;
            width: 100%;
            flex-direction: row;
            box-sizing: border-box;
            display: flex;
          "
        >
          <div
            class="utility-chartContainer"
            fxLayout="row wrap"
            fxFlex="100%;"
            fxFill
            [chart]="utilityConsumptionChart"
          ></div>
        </div>
      </div>
      <div
        class="dashboard-wrapper chart-2"
        fxLayout="row wrap"
        fxFlex="49%;"
        fxFlex.lt-xl="100%;"
      >
        <div
          class="yearly-stats-row"
          fxFlex="100%;"
          fxLayoutAlign="center left"
        >
          <div id="yearly-stats-title" fxFlex="50%;">
            <span class="header-title" id="yearly-stats">{{
              'overview.longTermTrends.yearlyStatistics' | translate
            }}</span>
          </div>
          <div id="yearly-stats-chart" fxFlex="50%;">
            <div class="row">
              <div class="col-md-12"></div>
            </div>
          </div>
        </div>
        <div
          id="chart2Container"
          fxFill
          style="
            height: 100%;
            min-height: 100%;
            min-width: 100%;
            width: 100%;
            flex-direction: row;
            box-sizing: border-box;
            display: flex;
          "
        >
          <div
            id="utility-chart2Container"
            fxLayout="row wrap"
            fxFlex="100%;"
            fxFill
            [chart]="utilityConsumptionChart2"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div style="display: flex">
    <div
      class="dashboard-wrapper"
      id="daily-stats-row"
      fxLayout="row wrap"
      fxFlex="100%;"
      fxFlex.lt-xl="100%;"
    >
      <div
        id="daily-stat-header"
        fxFlex="100%;"
        fxLayout="row wrap"
        fxLayoutAlign="center left"
        style="height: 10%"
      >
        <div id="daily-stats-title" fxFlex="50%;">
          <span class="header-title" id="daily-stats">{{
            'overview.longTermTrends.dailyStatistics' | translate
          }}</span>
        </div>
        <div
          id="date-change-row"
          fxLayout="row wrap"
          fxFlex="50%;"
          fxFlex.xs="100%;"
          fxFlex.lt-xl="100%;"
        >
          <div>
            <mat-form-field id="form-field-date-picker">
              <input
                matInput
                [matDatepicker]="picker1"
                [formControl]="startDate"
                (dateChange)="addEvent('change', $event)"
                [max]="max"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker1"
              ></mat-datepicker-toggle>
              <mat-datepicker
                #picker1
                [startView]="startView"
                (yearSelected)="chosenStartDate_YearHandler($event, picker1)"
                (monthSelected)="chosenStartDate_MonthHandler($event, picker1)"
                disabled="false"
              ></mat-datepicker>
              <mat-error *ngIf="startDate.invalid">{{
                'overview.invalidDate' | translate
              }}</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field id="form-field-date-picker2">
              <input
                matInput
                [matDatepicker]="picker2"
                [formControl]="endDate"
                (dateChange)="addEvent('change', $event)"
                [max]="max"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker2"
              ></mat-datepicker-toggle>
              <mat-datepicker
                #picker2
                [startView]="startView"
                (yearSelected)="chosenEndDate_YearHandler($event, picker2)"
                (monthSelected)="chosenEndDate_MonthHandler($event, picker2)"
                disabled="false"
              ></mat-datepicker>
              <mat-error *ngIf="endDate.invalid">{{
                'overview.invalidDate' | translate
              }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div id="chart3Container" fxFill>
        <div
          id="utility-chart3Container"
          fxLayout="row wrap"
          fxFlex="100%;"
          fxFill
          [chart]="utilityConsumptionChart3"
        ></div>
      </div>
    </div>
  </div>
</mat-expansion-panel>
